module.exports = __webpack_public_path__ + "img/log-out-02.60653ed3.svg";